import React, {ReactElement} from "react";

import {css, generateKeyId} from "/src/utils/utils";
import translate from "/src/utils/translate";

import LinkTag from "../../buttons/link-tag/LinkTag";

import * as styles from "./search-common-terms.module.scss";

interface SearchCommonTermsProps {
  tabIndex?: number;
  classes?: string;
}

const TERMS: Array<string> = [
  "Flexport Capital",
  "Air Freight",
  "Flexport",
  "Insurance",
  "Services",
  "Shipping",
];

const SearchCommonTerms = (props: SearchCommonTermsProps): ReactElement => {
  const {tabIndex = 0, classes} = props;

  return (
    <div className={css(styles.searchCommonTerms, classes!)}>
      <h4 className={css("h4", styles.searchCommonTerms__header)}>
        {translate("Common Searches")}
      </h4>
      <ul
        aria-label={translate("Common Searches")}
        className={styles.searchCommonTerms__list}
      >
        {TERMS.map((term: string, i: number) => {
          return (
            <li
              key={generateKeyId(`search-common-terms-${term}-${i}`)}
              className={styles.searchCommonTerms__item}
            >
              <LinkTag
                tabIndex={tabIndex}
                classes={css("h3", styles.searchCommonTerms__link)}
                href={encodeURI(`/search?q=${term}&page=1`)}
              >
                {term}
                {i === TERMS.length - 1 ? "" : ","}&nbsp;
              </LinkTag>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SearchCommonTerms;
